// Modules
import { useEffect } from 'react'
// Application
import { useCustomLayout } from 'redesign/hooks/useCustomLayout'
import { useCustomLayoutStore } from 'redesign/store'
import { useCurrentLaboratory } from '../useCurrentLaboratory'

export const useInitializeCustomLayout = () => {
    const { layoutConfig, activeLayout, activeLoginPage } = useCustomLayout()
    const { isSet, updateCustomLayout } = useCustomLayoutStore()
    const { currentLaboratory } = useCurrentLaboratory()

    useEffect(() => {
        if (!currentLaboratory && (!isSet || layoutConfig)) {
            updateCustomLayout({ layoutConfig, activeLayout, activeLoginPage })
        }
        if (currentLaboratory) {
            updateCustomLayout({
                layoutConfig: undefined,
                activeLayout: { default: true, mobileService: false },
                activeLoginPage: undefined,
            })
        }
    }, [activeLayout, activeLoginPage, currentLaboratory, isSet, layoutConfig, updateCustomLayout])
}
